export default "__VITE_ASSET__CGwjvp29__"